export default __webpack_public_path__ + "static/media/SconeProductInfo3.b2d27135.jpg";